import markUrl from '~/assets/brand/sola-mark.svg'
import styles from './SolaMark.module.css'

/*
 * Named `identity/` rather than `brand/` on purpose: `~/types/brand.ts` already
 * uses "brand" for nominal types, and one word meaning two things in one
 * repository is how the "Checkpoint 2.5" confusion started. The artwork itself
 * lives at `~/assets/brand/`, where the word is unambiguous.
 */

interface SolaMarkProps {
  /** `sm` Today header · `md` Settings identity · `lg` Project Setup, step one. */
  size: 'sm' | 'md' | 'lg'
}

/**
 * The Sola mark (D-089).
 *
 * **Always decorative.** It appears only beside visible "Project Sola" or "Today"
 * text, so `alt=""` is correct rather than lazy — an alt of "Project Sola" beside
 * the words *Project Sola* makes a screen reader say it twice. The canonical SVG
 * also carries `aria-hidden`, so it is silent however it is embedded, and an
 * `<img>` is never focusable, so it cannot land in the tab order.
 *
 * **The size is fixed and the image cannot outgrow its box.** `e2e/viewport.spec.ts`
 * measures the bounding rect of every element in the document at 390 px, so an
 * image that could exceed its container would fail the whole suite on whichever
 * screen it appeared on.
 *
 * No glow, no shadow, no animation — the mark must read against the near-black
 * interface on its own.
 */
export function SolaMark({ size }: SolaMarkProps) {
  return <img src={markUrl} alt="" class={`${styles.mark} ${styles[size]}`} />
}
